import api from '../lib/axios';
export const getCitizenBlocks = () => api.get('/api/admin/citizen-blocks').then((r) => r.data.data);
export const blockCitizen = (userId, note) => api.post('/api/admin/citizen-blocks', { user_id: userId, note }).then((r) => r.data);
export const unblockCitizen = (id) => api.delete(`/api/admin/citizen-blocks/${id}`).then((r) => r.data);
